import {RequestService} from '../RequestService/RequestService';

export class FilterJobsController {

    constructor() {
    const jobsContainers = document.querySelectorAll('.js-jobsFilter');

    if (jobsContainers.length > 0) {
      [].forEach.call(jobsContainers, (jobsContainer) => {
        jobsContainer.addEventListener('click', e => {
        e.preventDefault();
        let icon = document.querySelector('.js-chevron');
        if (icon) {
            if (jobsContainer.dataset.sort === 'DESC') {
                icon.classList.remove('icon-chevron-up');
                icon.classList.add('icon-chevron-down');
            } else {
                icon.classList.remove('icon-chevron-down');
                icon.classList.add('icon-chevron-up');
            }
        }
        this.getFilteredJobs(jobsContainer);
        });
      });
    }
  }

  private async getFilteredJobs(jobsContainer) {
    const formData = new FormData();
    formData.append('sort', jobsContainer.dataset.sort);
    const options = {
     method: 'POST',
     body: formData,
    };
    const data = await new RequestService().getRequest(jobsContainer.dataset.url, options);
    const resultContainer = document.querySelector('.jobs-container__body');
    if (resultContainer) {
     resultContainer.innerHTML = '';
     resultContainer.insertAdjacentHTML('beforeend', data.replace(/&amp;/g, '&'));
     if ( jobsContainer.dataset.sort === 'DESC') {
      jobsContainer.dataset.sort = 'ASC';
     } else {
       jobsContainer.dataset.sort = 'DESC';
     }
    }
  }
}
